import { PkBadge, PkIdentifier } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

interface TeamDisplayProps {
  isNationalTeam: boolean;
  isTeamAvailable: boolean;
  internationalName: string;
  countryCode?: string;
  displayName?: string;
  logoUrl?: string;
  slot: 'prefix' | 'suffix';
  isDesktop: boolean;
  badgeSize: number;
  clubName: string;
}

const TeamDisplay = ({
  isTeamAvailable,
  isNationalTeam,
  internationalName,
  countryCode,
  displayName,
  logoUrl,
  slot,
  isDesktop,
  badgeSize,
  clubName,
}: TeamDisplayProps) => {
  const { t } = useTranslation();

  if (!isTeamAvailable) {
    return <div />;
  }

  const identifierAlign = slot === 'prefix' ? 'left' : 'right';

  return (
    <PkIdentifier
      type={'horizontal'}
      alignment={identifierAlign}
      className={`${isDesktop ? 'pk-d-sm--flex pk-justify-content-sm--center' : ''}  pr-flex-direction--row`}
    >
      <span
        slot={slot}
        className={slot === 'prefix' ? 'pk-mr--xs pk-mr-md--m pk-pr--s' : 'pk-ml--xs pk-ml-md--m pk-pl--s'}
      >
        <PkBadge
          alt={internationalName}
          size={badgeSize}
          badge-title={displayName}
          fallbackImage="club-generic-badge"
          src={logoUrl}
          className="pr-badge-size--64"
        />
      </span>
      <span slot="primary" className={`${clubName} pk-text--wrap pk-d--block`}>
        {!isDesktop && isNationalTeam ? countryCode : displayName}
      </span>
      {isNationalTeam && (
        <span
          slot="primary"
          className={clsx('pk-text--text-03', {
            'pk-font-size--m': isDesktop,
            'pk-font-size--s': !isDesktop,
          })}
        >
          {t('all_clubs')}
        </span>
      )}
    </PkIdentifier>
  );
};

export default TeamDisplay;
